import { useContext } from "react";

import { AppProviderContext } from "../AppProvider";

export const useFileProvider = () =>
  useContext(AppProviderContext).fileProvider;
